<template>
  <form method="post" @submit.prevent="send">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title is-centered">
          {{ $t('attributes.add') + $t('attributes.collaborate_activity') }}
        </p>
      </header>
      <section class="modal-card-body">
        <form-wrapper :validator="$v.form">
          <form-group
            horizontal
            name="active"
            :label="$t('attributes.activation_status')"
          >
            <b-switch v-model="form.active" name="active"></b-switch>
          </form-group>

          <form-group
            horizontal
            name="active"
            :label="$t('attributes.activation_type')"
          >
            <b-select v-model="form.type">
              <option :value="0">正常版型</option>
              <option :value="1">純單參團版(無填基資)</option>
            </b-select>
          </form-group>

          <form-group
            horizontal
            name="collaborate_id"
            attribute="attributes.collaborate"
            :label="$t('attributes.collaborate')"
          >
            <b-autocomplete
              v-model="collaborate_name"
              name="collaborate_name"
              field="name"
              :data="filteredCollaborates"
              :loading="isLoading"
              :placeholder="
                $t('message.please_input') +
                  $t('attributes.collaborate') +
                  $t('attributes.name')
              "
              :open-on-focus="true"
              @typing="filteringCollaborates"
              @select="onSelectCollaborate"
            >
              <template #empty>
                No results found
              </template>
            </b-autocomplete>
          </form-group>

          <form-group horizontal name="name" :label="$t('attributes.name')">
            <b-input
              v-model="form.name"
              name="name"
              :placeholder="$t('message.please_input') + $t('attributes.name')"
              expanded
            >
            </b-input>
          </form-group>
        </form-wrapper>
      </section>

      <footer class="modal-card-foot">
        <b-button :loading="sending" @click="$parent.close()">
          {{ $t('attributes.cancel') }}
        </b-button>
        <b-button
          :loading="sending"
          :disabled="isLoading"
          type="is-primary"
          native-type="submit"
        >
          {{ $t('attributes.add') }}
        </b-button>
      </footer>
    </div>
  </form>
</template>

<script>
import debounce from 'lodash/debounce'
import { required, maxLength } from 'vuelidate/lib/validators'
import { FIRM_COLLABORATES_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'

export default {
  name: 'ActivityCreateForm',

  props: {
    sending: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isLoading: false,
      collaborates: [],
      filteredCollaborates: [],
      selectedCollaborate: null,
      collaborate_name: '',
      form: {
        active: false,
        type: 0,
        collaborate_id: null,
        name: ''
      }
    }
  },
  validations: {
    form: {
      active: { required },
      type: { required },
      collaborate_id: { required },
      name: { required, maxLength: maxLength(50) }
    }
  },
  mounted() {
    this.loadCollaborates()
  },
  methods: {
    async loadCollaborates() {
      const api = `${FIRM_COLLABORATES_API}/list`

      this.isLoading = true
      try {
        const res = await this.axios.get(api)
        this.collaborates = res.data.data
        this.filteringCollaborates()
      } catch (e) {
        this.collaborates = []
        this.filteredCollaborates = []
        this.selectedCollaborate = null

        notifyService.fetch_error('collaborate', e)
      } finally {
        this.isLoading = false
      }
    },
    filteringCollaborates: debounce(function() {
      this.filteredCollaborates = this.collaborates.filter(option => {
        return (
          option.name
            .toString()
            .toLowerCase()
            .indexOf(this.collaborate_name.toLowerCase()) >= 0
        )
      })
    }, 500),
    onSelectCollaborate(option) {
      this.selectedCollaborate = option
      this.form.collaborate_id =
        this.selectedCollaborate && this.selectedCollaborate.id
    },
    async send() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      this.$emit('onSend', this.form)
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-card {
  min-height: 480px;
}
</style>
